import { Hidden, Image } from '@doist/marketist'

import css from './feature-radio-tile.module.css'

import type { ReactElement } from 'react'

function RadioTileImage({ src }: { src: string }) {
    return (
        <Hidden above="md">
            <Image src={src} className={css.radioTileImage} height={472} width={590} alt="" />
        </Hidden>
    )
}

function RadioTileScene({ scene }: { scene: ReactElement | string }) {
    if (typeof scene === 'string') {
        return <RadioTileImage src={scene} />
    }

    return <Hidden above="md">{scene}</Hidden>
}

function SceneImage({ src }: { src: string }) {
    return <Image src={src} className={css.sceneImage} height={472} width={590} alt="" />
}

function SceneWrapper({ scene }: { scene: ReactElement | string }) {
    if (typeof scene === 'string') {
        return <SceneImage src={scene} />
    }
    return <>{scene}</>
}

export { RadioTileImage, RadioTileScene, SceneImage, SceneWrapper }
